import { render } from "./IconRemoveCircleOutline.vue?vue&type=template&id=3ae016af"
import script from "./IconRemoveCircleOutline.vue?vue&type=script&lang=js"
export * from "./IconRemoveCircleOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__